import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { map, Observable } from 'rxjs';
import { APPROVE_PAYMENT, CANCEL_PAYMENT, CREATE_PAYMENT, GENERATE_PAYMENT_PDF, UPDATE_PAYMENT } from '../graphql/mutation/payments.mutation';
import { BANK_ACCOUNTS, CREDIT_CARDS, FIND_ALL_PAYMENTS_PAGINATION, GET_BILLS, GET_INVOICES, GET_PAYMENT_BY_ID } from '../graphql/query/payments.query';

@Injectable({
  providedIn: 'root',
})
export class PaymentsService {
  constructor(private apollo: Apollo) {}

  createPayments(
    createPaymentInput: any,
    invoiceIDAmountInput: any,
    billIDAmountInput: any
  ): Observable<any> {
    return this.apollo
      .use('accounts')
      .mutate({
        mutation: CREATE_PAYMENT,
        variables: {
          createPaymentInput: createPaymentInput,
          invoiceIDAmountInput: invoiceIDAmountInput,
          billIDAmountInput: billIDAmountInput,
        },
        fetchPolicy: 'network-only',
      })
      .pipe(map((result: any) => result.data.createPayment || []));
  }

  updatePayment(
    id: any,
    updatePaymentInput: any,
    invoiceIDAmountInput: any,
    billIDAmountInput: any
  ): Observable<any> {
    return this.apollo
      .use('accounts')
      .mutate({
        mutation: UPDATE_PAYMENT,
        variables: {
          id:id,
          updatePaymentInput: updatePaymentInput,
          invoiceIDAmountInput: invoiceIDAmountInput,
          billIDAmountInput: billIDAmountInput,
        },
        fetchPolicy: 'network-only',
      })
      .pipe(map((result: any) => result.data.updatePayment || []));
  }

  approvePayment( id: any): Observable<any> {
    return this.apollo
      .use('accounts')
      .mutate({
        mutation: APPROVE_PAYMENT,
        variables: {id:id},
        fetchPolicy: 'network-only',
      })
      .pipe(map((result: any) => result.data.approvePayment || []));
  }

  cancelPayment( paymentId: any): Observable<any> {
    return this.apollo
      .use('accounts')
      .mutate({
        mutation: CANCEL_PAYMENT, 
        variables: {paymentId:paymentId},
        fetchPolicy: 'network-only',
      })
      .pipe(map((result: any) => result.data.cancelPayment || []));
  }
  generatePaymentPdf( id: any): Observable<any> {
    return this.apollo
      .use('accounts')
      .mutate({
        mutation: GENERATE_PAYMENT_PDF, 
        variables: {id:id},
        fetchPolicy: 'network-only',
      })
      .pipe(map((result: any) => result.data.generatePaymentPdf || []));
  }

  findAllPaymentsWithPagination(input: any): Observable<any> {
    return this.apollo
      .use('accounts')
      .query<any>({
        query: FIND_ALL_PAYMENTS_PAGINATION,
        variables: {input},
        fetchPolicy: 'network-only',
      })
      .pipe(
        map((result) => result.data?.findAllPaymentsWithPagination || [])
      );
  }
  creditCards(search: any,branchId: any): Observable<any> {
    return this.apollo
      .use('accounts')
      .watchQuery<any>({
        query: CREDIT_CARDS,
        variables: {search,branchId},
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(
        map((result) => result.data?.creditCards || [])
      );
  }
  bankAccounts(search: any,branchId: any): Observable<any> {
    return this.apollo
      .use('accounts')
      .watchQuery<any>({
        query: BANK_ACCOUNTS,
        variables: {search,branchId},
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(
        map((result) => result.data?.bankAccounts || [])
      );
  }
  fetchOpenOrPartiallyPaidBills(vendorId : any): Observable<any> {
    return this.apollo
      .use('accounts')
      .watchQuery<any>({
        query: GET_BILLS,
        variables: {vendorId },
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(
        map((result) => result.data?.fetchOpenOrPartiallyPaidBills || [])
      );
  }
  fetchOpenOrPartiallyPaidInvoices(customerId : any): Observable<any> {
    return this.apollo
      .use('accounts')
      .watchQuery<any>({
        query: GET_INVOICES,
        variables: {customerId },
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(
        map((result) => result.data?.fetchOpenOrPartiallyPaidInvoices || [])
      );
  }
  payment(id : any): Observable<any> {
    return this.apollo
      .use('accounts')
      .watchQuery<any>({
        query: GET_PAYMENT_BY_ID,
        variables: {id},
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(
        map((result) => result.data?.payment || [])
      );
  }
}
